import { createContext, ReactNode, useContext } from 'react';
import { PaginationContextType, usePagination } from '../search-windows/use-pagination';

const PaginationContext = createContext<PaginationContextType | undefined>(undefined);

export function useEventSearchResultsPaginationContext() {
    const context = useContext(PaginationContext);
    if (context === undefined) {
        throw new Error(
            'useEventSearchResultsPaginationContext must be used within a EventSearchResultsPaginationProvider'
        );
    }
    return context;
}

export const EventSearchResultsPaginationProvider = ({ children }: { children: ReactNode }) => {
    const pagination = usePagination();
    return <PaginationContext.Provider value={pagination}>{children}</PaginationContext.Provider>;
};
